// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadImage_container__2WJuk","image":"UploadImage_image__3Olf7","icon":"UploadImage_icon__11kxj","controls":"UploadImage_controls__2Sff8"};